import { z } from "zod";

export const deliveryPointSearchDtoSchema = z.object({
  address: z.string(),
  addressComplementBuilding: z.string().nullable(),
  addressComplementLevel: z.string().nullable(),
  contractOwner: z.string(),
  pdl: z.string(),
  receptionDateTime: z.string().nullable(),
  zipCode: z.string(),
});

export type TDeliveryPointSearchDto = z.infer<typeof deliveryPointSearchDtoSchema>;
